(function (angular) {
    'use strict';

    angular.module('integration')
        /**
         * 
         */
        .controller('accessTokenWizardModal',
            ["$uibModalInstance", 'accessTokenService', '$stateParams', 'growlService', 'availablePermissions', 'availableTemplates', 'WizardHandler', 'accessTokenData',
                function ($uibModalInstance, accessTokenService, $stateParams, growlService, availablePermissions, availableTemplates, WizardHandler, accessTokenData) {

                    var vm = this;

                    vm.newAccessToken = {};

                    vm.jwt = undefined;

                    vm.nameExitValidation = function () {
                        return vm.accessTokenNameStepForm.$valid;
                    }

                    // Once the token is created, you cat go back ...
                    vm.canEnterStep = function () {
                        return vm.jwt === undefined;
                    }

                    vm.canExitStepTwo = function () {
                        return WizardHandler.wizard("accessTokenWizard").currentStepNumber() >= 2;
                    }

                    vm.canExitStepThree = function() {
                        return WizardHandler.wizard("accessTokenWizard").currentStepNumber() >= 3;
                    }

                    vm.create = function () {
                        vm.disabled = true;

                        var data = {
                            name: vm.newAccessToken.name,
                            profileId: vm.newAccessToken.profileId,
                            permissions: []
                        };
                        angular.forEach(vm.permissions, function (val) {
                            angular.forEach(val, function (isSet, perm) {
                                if (isSet && data.permissions.indexOf(perm) == -1) {
                                    data.permissions.push(perm);
                                }
                            });
                        });

                        accessTokenService.createAccessToken($stateParams.pickedApiSpaceId, data)
                            .then(function (response) {
                                // the array of tokens in the parent page
                                accessTokenData.push(response);
                                growlService.success('Access Token created');
                                vm.jwt = response.jwt;
                            }).catch(function (error) {
                                growlService.danger("Access Token wasn't created due to: " + error.statusText);
                            });
                    }

                    // once you have created the token you cant go back ;-)
                    vm.tokenExitValidation = function () {
                        return false;
                    }

                    vm.cancel = function () {
                        WizardHandler.wizard("accessTokenWizard").cancel();
                        $uibModalInstance.dismiss();
                    }

                    vm.finish = function () {
                        WizardHandler.wizard("accessTokenWizard").finish();
                        $uibModalInstance.dismiss();
                    }

                    vm.availableTemplates = availableTemplates;
                    vm.templateData = { pickedTemplates: {} };
                    vm.groups = {};
                    vm.newAccessToken = {};
                    vm.permissions = {};
                    vm.newPermissions = {};

                    vm.getUsableName = function (name) {
                        return name.split(' ').join('_');
                    };

                    function changePermissions(index) {
                        var pickedTemplate = vm.availableTemplates[index].permissions;
                        for (var k in pickedTemplate) {
                            for (var i in vm.permissions) {
                                var permSet = vm.permissions[i];
                                for (var j in permSet) {
                                    if (j == pickedTemplate[k]) {
                                        if (vm.templateData.pickedTemplates[index]) {
                                            permSet[j] = true;
                                        }
                                        else {
                                            if (vm.newAccessToken[i]) {
                                                vm.newAccessToken[i] = false;
                                            }
                                            permSet[j] = false;
                                        }
                                        break;
                                    }
                                }
                                vm.changeGroup(i);
                            }
                        }
                    }
                    vm.changeGroup = function (name) {
                        for (var i in vm.permissions[name]) {
                            if (!vm.permissions[name][i]) {
                                vm.newAccessToken[name] = false;
                                return 0;
                            }
                        }
                        vm.newAccessToken[name] = true;
                    };
                    vm.updatePermissionsByTemplate = function () {
                        for (var a in vm.availableTemplates) {
                            if (!vm.templateData.pickedTemplates[a]) {
                                changePermissions(a);
                            }
                        }
                        for (var a in vm.availableTemplates) {
                            if (vm.templateData.pickedTemplates[a]) {
                                changePermissions(a);
                            }
                        }
                    };
                    vm.updateTemplateByPermissions = function () {
                        var templateSets = [];
                        for (var a in vm.availableTemplates) {
                            templateSets[a] = {};
                            for (var b in vm.availableTemplates[a].permissions) {
                                templateSets[a][vm.availableTemplates[a].permissions[b]] = false;
                            }
                        }
                        for (var i in vm.permissions) {
                            var permSet = vm.permissions[i];
                            for (var j in permSet) {
                                if (permSet[j]) {
                                    for (var index in templateSets) {
                                        templateSets[index][j] = true;
                                    }
                                }
                            }
                        }
                        for (var k in templateSets) {
                            var check = true;
                            for (var l in templateSets[k]) {
                                if (!templateSets[k][l]) {
                                    check = false;
                                }
                            }
                            vm.templateData.pickedTemplates[k] = check;
                        }
                    };
                    vm.availablePermissionsCol = [];
                    vm.availablePermissions = availablePermissions;
                    vm.separatePermissions = function () {
                        var col = 0;
                        angular.forEach(vm.availablePermissions, function (val) {
                            if (!vm.availablePermissionsCol[col]) vm.availablePermissionsCol.push([]);
                            vm.availablePermissionsCol[col].push(val);
                            col = (col + 1) % 2;
                        });
                    };
                    vm.preparePermissionsStructure = function () {
                        var templateCheck = [];
                        for (var a in vm.availableTemplates) {
                            templateCheck.push([]);
                        }
                        angular.forEach(vm.availablePermissions, function (groupPermissions) {
                            vm.permissions[vm.getUsableName(groupPermissions.group)] = {};
                            angular.forEach(groupPermissions.permissions, function (singlePermission) {
                                vm.permissions[vm.getUsableName(groupPermissions.group)][singlePermission.permission] = false;
                                for (var i in vm.availableTemplates) {
                                    var template = vm.availableTemplates[i];
                                    for (var j in template.permissions) {
                                        if (singlePermission.permission == template.permissions[j]) {
                                            if (templateCheck[i].indexOf(singlePermission.permission) == -1) {
                                                templateCheck[i].push(singlePermission.permission);
                                            }
                                        }
                                    }
                                }
                            });
                        });
                        for (var a in vm.availableTemplates) {
                            if (vm.availableTemplates[a].permissions.length == templateCheck[a].length) {
                                vm.availableTemplates[a].visible = true;
                            }
                        }
                        vm.newPermissions = angular.copy(vm.permissions);
                    };

                    vm.copyToClipboard = function () {
                        var copyTextarea = document.querySelector('.token');
                        copyTextarea.select();
                        try {
                            document.execCommand('copy');
                            growlService.success('Token copied to clipboard');
                        } catch (err) {
                            growlService.danger("Token not copied, try manualy");
                        }
                    };

                    vm.updateArray = function (group) {
                        angular.forEach(vm.permissions[group], function (val, singlePerm) {
                            vm.permissions[group][singlePerm] = vm.newAccessToken[group];
                        });
                    };
                    vm.separatePermissions();
                    vm.preparePermissionsStructure();
                }]);

})(window.angular);
